interface AuthHeader {
  Authorization: string;
}

export const getAuthToken = (): AuthHeader | {} => {
  const isBrowser = typeof window !== 'undefined';
  const authHeader = isBrowser && sessionStorage.getItem('AUTH_HEADER');
  return authHeader ? JSON.parse(authHeader) : {};
};

export const setAuthToken = (): void => {
  const isBrowser = typeof window !== 'undefined';
  if (isBrowser) {
    if (
      window.ikea &&
      window.ikea.authentication &&
      window.ikea.authentication.getTokens
    ) {
      window.ikea.authentication.getTokens(
        (error: string | undefined, tokens: TokensInterface) => {
          const hasValidTokens = tokens && tokens.auth && tokens.auth.value;
          if (!error && hasValidTokens) {
            sessionStorage.setItem(
              'AUTH_HEADER',
              JSON.stringify({
                Authorization: `Bearer ${tokens.auth && tokens.auth.value}`,
              })
            );
          } else {
            sessionStorage.removeItem('AUTH_HEADER');
          }
        }
      );
    }
  }
};
